<div class="admin-layout">
  <router-outlet class="width-100pc"></router-outlet>
</div>
